var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.01727C8 7.26879 7.90396 7.52028 7.71229 7.71205L1.67776 13.7465C1.29388 14.1304 0.671503 14.1304 0.287787 13.7465C-0.095929 13.3628 -0.095929 12.7405 0.287787 12.3566L5.62748 7.01727L0.287974 1.67786C-0.0957424 1.29398 -0.0957423 0.671789 0.287974 0.288104C0.67169 -0.0959533 1.29407 -0.0959533 1.67794 0.288104L7.71248 6.32248C7.90418 6.51434 8 6.76583 8 7.01727Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.8011e3b15298341de1e6e292a4c4f13a.svg";
export { ForwardRef as ReactComponent };